.hidden {
  position: absolute;
  right: 8px;
  color: var(--tuna-palette-text-disabled);
  font-style: italic;
  font-size: 0.5rem;
}

.hiddenChildren {
  display: none;
}
